import React from "react";
import { Navigate, useLocation, useParams } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { clientSlug, portalBasePath } from "../lib/portalPaths";

/**
 * Ensures URL slug matches active client; admin must have client context selected.
 * Client portals at /{company} only when activated (portal_access_granted_at).
 * Until then, clients are sent to /{company}/proposal.
 */
export function ClientPortalGate({ children }) {
  const { clientSlug: paramSlug } = useParams();
  const { user, client, loading } = useAuth();
  const location = useLocation();

  if (loading) return <div className="p-12 t-meta">Loading…</div>;
  if (!user) return <Navigate to="/" replace />;

  if (user.role === "admin" && !client) return <Navigate to="/admin" replace />;
  if (!client) return <Navigate to="/" replace />;

  const expected = clientSlug(client);
  if (paramSlug !== expected) {
    const suffix = location.pathname.replace(new RegExp(`^/${paramSlug}`), "") || "";
    return <Navigate to={`${portalBasePath(client)}${suffix}${location.search || ""}`} replace />;
  }

  // Client workspace is only live after activation (invite / onboarding complete).
  if (user.role === "client" && !user.portal_access_granted_at) {
    return <Navigate to={`/${expected}/proposal`} replace />;
  }

  return children;
}
